import { FC } from "react";
import {
  Box,
  Container,
  Grid,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";

interface PainPoint {
  id: string;
  icon: string;
  title: string;
  description: string;
  stats: string;
}

interface WordPressPainPointsSectionProps {
  content: {
    title: string;
    subtitle: string;
    problems: PainPoint[];
  };
}

export const WordPressPainPointsSection: FC<WordPressPainPointsSectionProps> = ({ content }) => (
  <Box py={{ base: "16", md: "24" }} bg="white">
    <Container maxW="7xl">
      <VStack spacing="8" mb="12" textAlign="center">
        <Heading as="h2" fontSize={{ base: "3xl", md: "4xl" }}>
          {content.title}
        </Heading>
        <Text fontSize={{ base: "lg", md: "xl" }} color="gray.600" maxW="3xl">
          {content.subtitle}
        </Text>
      </VStack>

      <Grid
        templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }}
        gap="8"
      >
        {content.problems.map((problem) => (
          <Box
            key={problem.id}
            p="6"
            bg="gray.50"
            borderRadius="lg"
            borderWidth="1px"
            borderColor="gray.200"
            _hover={{
              boxShadow: "lg",
              transform: "translateY(-4px)",
              borderColor: "blue.300",
            }}
            transition="all 0.3s"
          >
            <VStack align="start" spacing="4">
              <Text fontSize="4xl">{problem.icon}</Text>
              <Heading as="h3" fontSize="xl" color="gray.900">
                {problem.title}
              </Heading>
              <Text fontSize="md" color="gray.700" lineHeight="tall">
                {problem.description}
              </Text>
              <Box
                mt="4"
                p="3"
                bg="blue.50"
                borderRadius="md"
                borderLeftWidth="4px"
                borderLeftColor="blue.500"
                w="full"
              >
                <Text fontSize="sm" fontWeight="semibold" color="blue.700">
                  {problem.stats}
                </Text>
              </Box>
            </VStack>
          </Box>
        ))}
      </Grid>
    </Container>
  </Box>
);
